import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import { SupportFilters, TSupport } from '../types';

import { supportsQueryKeys } from './query-keys';

export async function getSupports(
  params?: ParamsWithPagination<SupportFilters>
): Promise<PaginatedResponse<TSupport>> {
  return mediaManagerClient.get('api/v1/supports', {
    params: {
      limit: params?.limit,
      search: params?.search,
      offset: params?.offset,
    },
  });
}

type QueryFnType = typeof getSupports;

interface UseSupportsParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<SupportFilters>;
}

export function useSupports({ config, params }: UseSupportsParams = {}) {
  return useQuery({
    ...config,
    queryKey: supportsQueryKeys.list(params),
    queryFn: () => getSupports(params),
  });
}
